const zustandXOpts = {
    devtools: {
        enabled: process.env.NODE_ENV !== 'production'
    },
    persist: {
        enabled: true,
        name: 'htr24',
        partialize: (state) => ({
            token: state.token,
            chosenCompanyId: state.chosenCompanyId,
        }),
    }
}

export default zustandXOpts;